<i18n lang='yml' src='../i18n/DatePicker.yml'></i18n>
<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <div class='form-group' v-if="schedule_checkbox">
      <input id='schedule' type='checkbox' v-model='schedule' class='mr-1'>
      <label for='schedule'>{{ $t('schedule') }}</label>
    </div>
    <div class='form-group' v-if="schedule || !schedule_checkbox">
      <div class='col-md-12 datepicker'>
        <label class='d-none' :for='label_name'>{{ label }}</label>
        <label :for='`${label_name}_datepicker`'>{{ label }}</label>
        <div class= 'mb-2'>
          <span class='guiding-text'> {{ descriptor }} </span>
        </div>
        <input :name="input_name" :id='label_name' class='d-none' v-model='formattedDate'/>
        <flat-pickr :id='`${label_name}_datepicker`' name="date_picker" input-class='form-control' v-model='date' setTime="" :config='datePickerConfig()'></flat-pickr>
      </div>
    </div>
  </div>  
</template>

<script>
  import {French} from 'flatpickr/dist/l10n/fr.js';
  export default {
      props: {
        input_name: { type: String },
        label_name: { type: String },
        reminder_name: { type: String }, // when using this in reminder it needs the name to appear in the flat pickr input rather then the preceeding input
        time: {type: String},
        label: { type: String },
        descriptor: { type: String },
        preset_date: {type: String},
        locale: {type: String},
        schedule_checkbox: {type: Boolean, default: false},
      },
      data () {
          return {
              loading: true,
              schedule: false,
              date: new Date(),
              formattedDate: null,
              setTime: new Date()
          }
      },
      mounted() {
        if(this.preset_date) {
          this.date = new Date(this.preset_date)
        }
        this.loading = false;
      },
      methods: {
          // Sets up the basic configuration object for the date section of flatpickr
          // We enable the use of time and set it to 24 hours so we can properly parse it later
          datePickerConfig: function () {
            const _vm = this
            return { 
              enableTime: this.time == 'true',
              time_24hr: true,
              minuteIncrement: 1,
              locale: (this.locale=='fr') ? French : 'en',
              onChange: function(selectedDates, dateStr, instance) {
                _vm.formattedDate = selectedDates[0] ? selectedDates[0].toISOString() : null
              }
            };
          },
      }
  }
</script>
